import * as User from './User'
import DeathsAndDiseases from './DeathsAndDiseases'
import Lot from './Lot'
import Sale from './Sale'
import CoverageProcess from './CoverageProcess'
import AnimalWeight from './AnimalWeight'
import CouplePlanning from './CouplePlanning'
import PregnancyDiagnosis from './PregnancyDiagnosis'
import Report from './Report'
import Genotyping from './Genotyping'
import Movement from './Movement'
import Diagnosis from './Diagnosis'
import AnimalBirth from './AnimalBirth'
import Local from './Local'
import BirthCertificate from './BirthCertificate'
import Property from './Property'

const VALIDATIONS = {
  DeathsAndDiseases,
  Lot,
  Sale,
  CoverageProcess,
  AnimalWeight,
  CouplePlanning,
  PregnancyDiagnosis,
  Report,
  Genotyping,
  Movement,
  User,
  Diagnosis,
  AnimalBirth,
  Local,
  BirthCertificate,
  Property
}

export { VALIDATIONS }
